export default [
  'auto',
  '16:9',
  '4:3',
  '3:4',
  '1:1'
]
